// Attaches the self-hosted Supabase session token to every server-function RPC.
// Registered as a global `functionMiddleware` in src/start.ts.
import { createMiddleware } from "@tanstack/react-start";
import { supabase } from "./browser-client";

export const attachSelfHostedAuth = createMiddleware({ type: "function" }).client(async ({ next }) => {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  return next({
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
});
